import { ImageProps } from "../../Models/Image";
import { ImageStyled } from "./Image.styled";

const Image = ({ srcImg, marginImg, widthImg, heightImg }: ImageProps) => {
  return (
    <ImageStyled
      src={srcImg}
      $margin={marginImg}
      width={widthImg}
      height={heightImg}
    />
  );
};

export default Image;
